/**
 * Simple global event bus to synchronize dashboard data
 * across different components and hooks.
 */

export const DASHBOARD_EVENTS = {
  REFRESH: 'dashboard:refresh',
} as const;

/**
 * Emit a global signal to refresh dashboard metrics, counts and lists.
 */
export function emitDashboardRefresh() {
  window.dispatchEvent(new CustomEvent(DASHBOARD_EVENTS.REFRESH));
}

/**
 * Hook logic: listen for the refresh event.
 * (This will be integrated inside the hooks themselves)
 */
